import { useParams } from "react-router-dom";
import { useContext } from "react";
import { MyContext } from "../../context/MyContext";
import AutopayContent from "./components/AutopayContent";
import Air2Open from "./components/Air2Open";
import Air10431 from "./components/Air10431";
import Air202509 from "./components/Air202509";
import EduMain from "./components/EduMain";
import GuideFloating from "./floating/GuideFloating";
import AirHeader from "../../components/AirHeader";

const GuideView = (props) => {
  const { guideId } = useParams(); // URL 파라미터에서 guideId 받아오기
  const { isMobile } = useContext(MyContext);

  // guideId에 따른 컨텐츠 렌더링 함수
  const renderContent = () => {
    switch (guideId) {
      case "edumain":
        return <EduMain />;
      case "main":
        return <Air202509 />;
      case "10431":
        return <Air10431 />;
      case "Air2Open":
        return <Air2Open />;
      case "250710":
        return <AutopayContent />;
      default:
        return <Air202509 />; // 기본값: main 콘텐츠
    }
  };

  return (
    <div className="flex flex-col h-full w-full bg-white overflow-hidden">
      {/* 모바일 헤더 */}
      {isMobile && <AirHeader type="sub" title="이용가이드" />}

      {/* 스크롤 가능한 콘텐츠 영역 */}
      <div className="flex-1 overflow-y-auto relative">
        {/* 플로팅 버튼 */}
        <GuideFloating />

        {/* 메인 콘텐츠 */}
        <div className="air2509_layout-contents-outer">
          <div className="layout-contents center space-bottom">
            <div className="layout-subpage-tab-wrap">
              <div
                data-sentry-component="SubEventDetailView"
                data-sentry-source-file="sub-event-detail-view.tsx"
              >
                <div id="SubEventDetailView" className="ui-sub-page-view">
                  {renderContent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GuideView;
